<template>
    <div class="ui clearing segment">
        <div class="ui form" :class="{ loading: saving }" v-if="localItem !== null">
            <div class="inline fields">
                <label>Select the link type</label>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" v-model="linkType" name="linkType" value="url">
                        <label>Link</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" v-model="linkType" name="linkType" value="page">
                        <label>Page</label>
                    </div>
                </div>
                <div class="field">
                    <div class="ui radio checkbox">
                        <input type="radio" v-model="linkType" name="linkType" value="folder">
                        <label>Menu Folder</label>
                    </div>
                </div>
            </div>
            <div class="field" :class="{ error: errors.has('display_name') }">
                <label>Display Name</label>
                <input type="text" v-model="localItem.display_name" name="display_name" placeholder="Display Name" v-validate="{required: true, min: 3, max: 35}">
                <label v-if="errors.has('display_name')">{{errors.first('display_name')}}</label>
            </div>
            <div class="field" :class="{ error: errors.has('sort_index') }">
                <label>Sort Index</label>
                <input type="number" v-model.lazy.number="localItem.sort_index" placeholder="Sort Index" v-validate="{ required: true, min: 0, max: 1000 }">
                <label v-if="errors.has('sort_index')">{{errors.first('sort_index')}}</label>
            </div>
            <div class="field">
                <div class="ui checkbox">
                    <input type="checkbox" v-model="localItem.active" name="active">
                    <label>Active</label>
                </div>
            </div>
            <div class="field" v-if="linkType === 'url'" :class="{ error: errors.has('url') }">
                <label>Url</label>
                <input type="text" v-model="localItem.url" placeholder="URL" name="url" v-validate="{required: true, url: true}">
                <label v-if="errors.has('url')">{{errors.first('url')}}</label>
            </div>
            <div class="field" v-if="linkType === 'page'">
                <label>Page</label>
                <admin-page-selection-dropdown @selection="onPageSelection" :selection="localItem.pageId" :pages="pages" v-if="pages !== null && localItem !== null"></admin-page-selection-dropdown>
            </div>

            <button type="button" class="ui right floated primary button" @click="save">Save</button>
            <button type="button" class="ui right floated button" @click="$emit('cancel')">Cancel</button>
            <button type="button" class="ui right floated red button" @click="$emit('delete', item)" :class="{disabled: item.children !== undefined && item.children.length > 0 || item.id === undefined}">Delete</button>
            <button type="button" class="ui right floated button" @click="onAddItem" v-if="linkType === 'folder'">Add
                Item
            </button>
        </div>
    </div>
</template>

<script>
import { HTTP } from '../../http';
import AdminPageSelectionDropdown from './AdminPageSelectionDropdown';

export default {
  components: { AdminPageSelectionDropdown },
  name: 'admin-menu-item-editor',

  props: ['item'],

  watch: {
    item() {
      this.assignLinkType();
      this.localItem = JSON.parse(JSON.stringify(this.item));
    },
  },

  mounted() {
    this.assignLinkType();
    this.localItem = JSON.parse(JSON.stringify(this.item));
    this.loadPages();
  },

  data() {
    return {
      saving: false,
      linkType: '',

      localItem: null,
      pages: null,
    };
  },

  methods: {
    onPageSelection(value) {
      this.localItem.pageId = parseInt(value);
    },

    onAddItem() {
      if (this.linkType === 'folder') {
        let itemTemplate = {
          active: false,
          display_name: '<new-item>',
          url: null,
          pageId: null,
          sort_index: 995,
          parentId: this.localItem.id || null,
        };

        this.$store.commit('adminMenu/appendNew', { parent: this.item, child: itemTemplate });

        this.item.expanded = true;

        this.$emit('new-item', itemTemplate);
      }
    },

    save() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.saving = true;

          switch (this.linkType) {
            case 'url':
              this.localItem.pageId = null;
              delete this.localItem.children;
              break;
            case 'page':
              this.localItem.url = null;
              delete this.localItem.children;
              break;
            case 'folder':
              this.localItem.url = null;
              this.localItem.pageId = null;
              break;
          }

          this.$emit('save', this.localItem);
        }
      });
    },

    assignLinkType() {
      if (this.item.children !== undefined) {
        this.linkType = 'folder';
      } else if (this.item.url !== null) {
        this.linkType = 'url';
      } else if (this.item.page !== null) {
        this.linkType = 'page';
      }
    },

    loadPages() {
      HTTP.get('/pages/')
        .then((resp) => {
          this.pages = resp.data;
        })
        .catch((err) => context.commit('error/set', err.response.data, { root: true }));
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminMenuItemEditor.vue